import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { GetDecodedString } from "../../services/selfCheckinService";
import { setCurrentUser, setEncodedDataString } from "../../reducer/selfCheckinSlice";
import { useSearchParams } from "react-router-dom";

function UserLinkUrl() {

    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();    
    const getDecodeString = (str) => {        
        GetDecodedString(str).then((d) => {
            var obj = d.data;
            var temp = obj.split("_");

            if (temp.length !== 0) {
                let arr = {
                    ClientID: temp[0],
                    PropertyID: temp[1],
                    BookingNo: temp[2]
                }                
                dispatch(setCurrentUser(arr))
                navigate(`/HomePage/${str}`);
            }
        }).catch((ex) => {
            console.log("Decode Error :: ", ex)
        });
    }

    useEffect(() => {
        getDecodeString(searchParams.get('data'));
        dispatch(setEncodedDataString(searchParams.get('data')))
    }, [])
    return (
        <></>
    )
}
export default UserLinkUrl;